export const EXHAUSTIVE_ITEMS = [
  'Dossiers, temps et facturation',
  'Honoraires, frais et débours',
  'Facturation électronique conforme',
  'Gestion documentaire, emails et tâches',
  'Tableaux de bord et indicateurs clés',
  'Tamponnage numérique des pièces',
  'Relances, trésorerie et rapprochement bancaire',
  'Rapports financiers et performance du cabinet',
  'Et + encore...',
];

export const SIMPLICITY_ITEMS = [
  'Saisie des temps et facturation fluides',
  'Paramétrage adapté à votre pratique',
  'Abonnement flexible, sans engagement',
  'Tarification simple, sans surprise',
  'Interface intuitive, prise en main immédiate',
];

export const SERVICE_ITEMS = [
  "Équipe experte dédiée aux cabinets d'avocats",
  'Accompagnement personnalisé sans surcoût',
  'Support client réactif et disponible',
];

export const INNOVATION_ITEMS = [
  'Fonctionnalités performantes et fiables',
  'Évolutions guidées par vos usages',
  'Améliorations régulières',
];